(function (appComponents) {

	appComponents.controllers.supportLibrary = function (Components) {
		var supportLibrary = {};

		supportLibrary.name = "supportLibrary";
		supportLibrary.currentCatCode = null;

		supportLibrary.opts = {
			numToDisplay: 10
		};

		Components.getControllerPrototype().extend(supportLibrary);

		supportLibrary.pager = supportLibrary._getService("helpers").getPager(supportLibrary);
		supportLibrary._modals = supportLibrary._getService("modals");

		supportLibrary.context.pagerData = supportLibrary.pager.data;

		supportLibrary.elements = {
			get resultsBlock() {
				return $('[pc-container="support-library--results-block"]');
			},
			get table() {
				return $('[pc-container="support-library--table"]');
			},
			get pager() {
				return $('[pc-container="support-library--pager"]');
			},
			get firstCategories() {
				return $('[pc-container="support-library--first-categories-block"]');
			},
			get resultsCount() {
				return $('[pc-container="support-library--results-count"]');
			}

		};

		supportLibrary.bindings = function () {
			$(document).off("submit", '[pc-container="support-library--search-form"]').on("submit", '[pc-container="support-library--search-form"]', function () {
				supportLibrary.handlers.onSearchFormSubmit(this);
				return false;
			});
			$(document).off("submit", '[pc-container="support-library--upload-motor-docs"]').on("submit", '[pc-container="support-library--upload-motor-docs"]', function () {
				var form = $("[pc-container='support-library--upload-motor-docs']")[0];
				supportLibrary.handlers.uploadMotorDocs(form);
			});
			$(document).off("click", '[pc-container="support-library--first-category-title"]').on("click", '[pc-container="support-library--first-category-title"]', function () {
				var firstCatCode = $(this).attr("pc-value");

				supportLibrary.handlers.onFirstCatTitleClick(firstCatCode);
			});
			//PC Store Help Doc
			$(document).off("click", '[pc-container="support-library--training-category-title"]').on("click", '[pc-container="support-library--training-category-title"]', function () {
                var firstCatCode = $(this).attr("pc-value");
                var firstCatName = $(this).text();
                supportLibrary.handlers.onFirstTrainTitleClick(firstCatCode, firstCatName);
            });
			$(document).off("click", '[pc-container="support-library--item-add-to-favs"]').on("click", '[pc-container="support-library--item-add-to-favs"]', function () {
				var docCode = $(this).closest('[pc-container="support-library--item"]').attr("pc-value");

				supportLibrary.handlers.onAddToFavourites(docCode);
			});
			$(document).off("click", '[pc-container="support-library--item-remove-from-favs"]').on("click", '[pc-container="support-library--item-remove-from-favs"]', function () {
				var pk = $(this).closest('[pc-container="support-library--item"]').attr("pc-value");

				supportLibrary.handlers.onRemoveFromFavourites(pk);
			});

			$(document).off("click", '[pc-container="support-library--favourites"]').on("click", '[pc-container="support-library--favourites"]', function () {
				supportLibrary.handlers.onClickOnFavourites();
			});

			$(document).off("click", '[pc-container="support-library--reset-filters-btn"]').on("click", '[pc-container="support-library--reset-filters-btn"]', function () {
				$('[pc-container="support-library--search-form"]').trigger("reset");
				supportLibrary.handlers.onResetFilters();
			});
		};

		supportLibrary.populateFirstCatItems = function () {
			return supportLibrary._api.supportLibrary.getFirstCat().then(function (res) {
				if (res && res.status == 200) {
					supportLibrary.context.firstCatItems = res.body;
					return res.body;
				} else {
					console.log(res);
				}
			});
		};

		supportLibrary.populateSecondCatItems = function (firstCatCode) {
			return supportLibrary._api.supportLibrary.getSecondCat(firstCatCode).then(function (res) {
				if (res.status == 200 || res.status == 210) {
					supportLibrary.context.secondCatItems = res.body;
				} else {
					console.log(res);
				}
			});
		};

		supportLibrary.populateLiteratureItems = function () {
			return supportLibrary._api.supportLibrary.getLiterature().then(function (res) {
				if (res && res.status == 200) {
					supportLibrary.context.literature = res.body;
				} else {
					console.log(res);
				}
			});
		};

		supportLibrary.populateInitialContext = function () {
			var defToReturn = $.Deferred();

			var defFirstCat = supportLibrary.populateFirstCatItems().then(function (cats) {

				if (!cats) return this;
				var catToCheck = cats[0];
				supportLibrary.currentCatCode = catToCheck.code;

			});

			var defLiterature = supportLibrary.populateLiteratureItems();

			$.when(defFirstCat, defLiterature).then(function () {
				defToReturn.resolve();
			});

			return defToReturn;
		};

		supportLibrary.prepareSearchData = function () {
			var filters = supportLibrary.currentFilters;

			var searchData = {
				pageNumber: supportLibrary.pager.pageToSet,
				resultsPerPage: supportLibrary.pager.data.pageSize,
				primaryClass: supportLibrary.currentCatCode
			};

			jQuery.extend(searchData, filters);

			return searchData;
		};

		supportLibrary.searchDocsWithPager = function () {
			var searchData = supportLibrary.prepareSearchData();

			return supportLibrary._api.supportLibrary.searchDocs(searchData).then(function (res) {
				if (res.status == 200 || res.status == 210) {
					supportLibrary.parseDocResultsResponse(res.body);
				} else {
					console.log(res);
				}
			});
		};

		supportLibrary.searchFavouriteDocsWithPager = function () {
			// without pager for now
			return supportLibrary._api.supportLibrary.searchFavourites().then(function (res) {
				if (res.status == 200 || res.status == 210) {
					supportLibrary.parseFavResultsResponse(res.body);
				} else {
					console.log(res);
				}
			});
		};

		supportLibrary.parseDocResultsResponse = function (data) {
			supportLibrary.pager.data = data.pagination;
			supportLibrary.context.results = data.results;
			supportLibrary.context.pagerData = supportLibrary.pager.data;
		};

		supportLibrary.parseFavResultsResponse = function (data) {
			if (data == null) {
				supportLibrary.context.results = null;
				return;
			}
			supportLibrary.pager.data = data.pagination;
			supportLibrary.context.results = data.entries;
			supportLibrary.context.pagerData = supportLibrary.pager.data;
			supportLibrary.context.favCount = data.count;
		};
		supportLibrary.renderSearchResults = function () {
			supportLibrary._renderTemplate("resultsBlock", null, "ignoreAnim");

			supportLibrary._applyScript.base.select2();
			supportLibrary._applyScript.niceScroll();
		};

		supportLibrary.renderTableResults = function () {
			var html = supportLibrary.templates.table(supportLibrary.context);
			supportLibrary.elements.table.html(html);

			html = supportLibrary.templates.pager(supportLibrary.context);
			supportLibrary.elements.pager.html(html);

			supportLibrary.elements.resultsCount.text(supportLibrary.context.pagerData.totalNumberOfResults);

			supportLibrary._applyScript.base.select2();
			supportLibrary._applyScript.niceScroll();
		};

		supportLibrary.renderFavouritesResults = function () {
			var html = supportLibrary.templates.favouritesBlock(supportLibrary.context);
			supportLibrary.elements.resultsBlock.html(html);

			supportLibrary._applyScript.base.select2();
			supportLibrary._applyScript.niceScroll();
		};

		supportLibrary.setActiveCategoryByCode = function (code) {
			//PC Store Help Doc
			supportLibrary.context.prod_cat = true;
			supportLibrary.context.store_overview = supportLibrary.context.create_qo = supportLibrary.context.how_register =supportLibrary.context.store_faq =supportLibrary.context.motors_docs =supportLibrary.context.workflow= supportLibrary.context.operational_manual= false;
			supportLibrary.populateSecondCatItems(code).then(function () {

				supportLibrary.currentFilters = {};

				supportLibrary.pager.reset();

				supportLibrary.searchDocsWithPager().then(function () {
					supportLibrary.context.firstCatName = supportLibrary.elements.firstCategories.find("a[pc-value='" + code + "']").text();

					supportLibrary.renderSearchResults();

					supportLibrary.elements.firstCategories.find("li").removeClass("active")
						.find("a[pc-value='" + code + "']").closest("li").addClass("active");
				});
			});
		};
		//PC Store Help Doc
		supportLibrary.setActiveTrainingByCode = function (code, firstCatName) {
			supportLibrary.context.firstCatName = firstCatName;
			supportLibrary.context.prod_cat = false;
				supportLibrary.currentFilters = {};
				supportLibrary.pager.reset();
					if(code === "rmcategory_45"){
						supportLibrary.context.pagerData.totalNumberOfResults = 1;
						supportLibrary.context.store_overview = true;
						supportLibrary.context.create_qo = false;
						supportLibrary.context.how_register = false;
						supportLibrary.context.store_faq = false;
						supportLibrary.context.motors_docs = false;
						supportLibrary.context.workflow =false;
						supportLibrary.context.operational_manual = false;
					}else if(code === "rmcategory_46"){
						supportLibrary.context.pagerData.totalNumberOfResults = 4;
						supportLibrary.context.create_qo = true;
						supportLibrary.context.store_overview = false;
						supportLibrary.context.how_register = false;
						supportLibrary.context.store_faq = false;
						supportLibrary.context.motors_docs = false;
						supportLibrary.context.workflow =false;
						supportLibrary.context.operational_manual = false;
					}else if(code === "rmcategory_47"){
						supportLibrary.context.pagerData.totalNumberOfResults = 2;
						supportLibrary.context.how_register = true;
						supportLibrary.context.store_overview = false;
						supportLibrary.context.create_qo = false;
						supportLibrary.context.store_faq = false;
						supportLibrary.context.motors_docs = false;
						supportLibrary.context.workflow =false;
						supportLibrary.context.operational_manual = false;
					}
					else if(code === "rmcategory_48"){
						supportLibrary.context.pagerData.totalNumberOfResults = 10;
						supportLibrary.context.store_faq = true;
						supportLibrary.context.how_register = false;
						supportLibrary.context.store_overview = false;
						supportLibrary.context.create_qo = false;
						supportLibrary.context.motors_docs = false;
						supportLibrary.context.workflow =false;
						supportLibrary.context.operational_manual = false;
					}
					else if(code ==="motors_docs")
					{
						supportLibrary.context.pagerData.totalNumberOfResults = 1;
						supportLibrary.context.store_overview = false;
						supportLibrary.context.create_qo = false;
						supportLibrary.context.how_register = false;
						supportLibrary.context.store_faq = false;
						supportLibrary.context.motors_docs = true;
						supportLibrary.context.workflow =false;
						supportLibrary.context.operational_manual = false;
					}
					else if(code ==="rmcategory_workflow")
					{
						supportLibrary.context.pagerData.totalNumberOfResults = 14;
						supportLibrary.context.store_overview = false;
						supportLibrary.context.create_qo = false;
						supportLibrary.context.how_register = false;
						supportLibrary.context.store_faq = false;
						supportLibrary.context.motors_docs = false;
						supportLibrary.context.workflow = true;
						supportLibrary.context.operational_manual = false;
					}
					else if(code ==="operational_manual")
					{
						supportLibrary.context.pagerData.totalNumberOfResults = 9;
						supportLibrary.context.store_overview = false;
						supportLibrary.context.create_qo = false;
						supportLibrary.context.how_register = false;
						supportLibrary.context.store_faq = false;
						supportLibrary.context.motors_docs = false;
						supportLibrary.context.workflow =false;
						supportLibrary.context.operational_manual = true;
					}


					supportLibrary.renderSearchResults();

					supportLibrary.elements.firstCategories.find("li").removeClass("active").find("a[pc-value='" + code + "']").closest("li").addClass("active");
				
		};

		supportLibrary.handlers = {
			onResetFilters: function () {
				//supportLibrary.setActiveCategoryByCode(supportLibrary.currentCatCode);
				if(supportLibrary.context.prod_cat === true){
					supportLibrary.setActiveCategoryByCode(supportLibrary.currentCatCode);
				}else {
					supportLibrary.setActiveTrainingByCode(supportLibrary.currentCatCode, supportLibrary.context.firstCatName);
				}
				

			},
			onClickOnFavourites: function () {
				supportLibrary.elements.firstCategories.find("li").removeClass("active")
					.find("[pc-container='support-library--favourites']").closest("li").addClass("active");
				supportLibrary.searchFavouriteDocsWithPager().then(function () {
					supportLibrary.renderFavouritesResults();
				});
			},
			onAddToFavourites: function (docCode) {
				supportLibrary._api.supportLibrary.addToFavourites(docCode).then(function (res) {
					if (res.status == 200) {
						supportLibrary._modals.success.show(supportLibrary._messages.supportDocAddedToFav);
					} else {
						console.log(res);
					}
				});
			},
			onRemoveFromFavourites: function (pk) {
				supportLibrary._api.supportLibrary.removeFromFavourites(pk).then(function (res) {
					if (res.status == 200) {
						// supportLibrary._modals.success.show(supportLibrary._messages.supportDocRemovedFromFav);
						supportLibrary.searchFavouriteDocsWithPager().then(function () {
							supportLibrary.renderFavouritesResults();
						});
					} else {
						console.log(res);
					}
				});
			},
			onFirstCatTitleClick: function (firstCatCode) {
				supportLibrary.currentCatCode = firstCatCode;
				supportLibrary.setActiveCategoryByCode(supportLibrary.currentCatCode);
			},
			//PC Store Help Doc
			onFirstTrainTitleClick: function (firstCatCode, firstCatName) {
				supportLibrary.currentCatCode = firstCatCode;			
				supportLibrary.setActiveTrainingByCode(supportLibrary.currentCatCode, firstCatName);
			},
			onSearchFormSubmit: function (form) {
				var formData = supportLibrary._utils.getFormData(form);

				supportLibrary.pager.reset();

				supportLibrary.currentFilters = formData;

				supportLibrary.searchDocsWithPager().then(function () {
					supportLibrary.renderTableResults();
				});
			},
			uploadMotorDocs: function (form) {
				var formData = supportLibrary._utils.getFormData(form);
				supportLibrary._api.supportLibrary.uploadMotorDocs(form).then(function (res) {
					if (res && res.status == 200) {
						console.log(res);
					}
					else
					{
						console.log(res);
					}
				});
			},
			pager: {
				onPagerClick: function () {
					supportLibrary.searchDocsWithPager().then(function () {
						supportLibrary.renderTableResults();
					});
				}
			}
		};

		supportLibrary.init = function () {

			supportLibrary.populateInitialContext().then(function () {

				supportLibrary._renderPageTemplate();

				//supportLibrary.setActiveCategoryByCode(supportLibrary.currentCatCode);
				var path = app.router.params;
                //console.log("path "+path);
				if(path.indexOf('faq=true') != -1)
                {
                supportLibrary.setActiveTrainingByCode("rmcategory_48", "Frequently Asked Questions (FAQ)");
                }
            else if(path.indexOf('inventory=true') != -1)
                {
            	var loggedIn=app.role.flags.isUser;
            	console.log("loggedIn "+loggedIn);
            	if(typeof loggedIn =='undefined' || loggedIn === undefined)
            	{
            		$.cookie("prevUrl", window.location.href);
            		window.location.href="/rmstorefront/rm/en/USD/user/login";
            	}
            	else
            		{
            		$.cookie("prevUrl",null);
            		}
                supportLibrary.setActiveTrainingByCode("motors_docs", "Motor Inventory");
                }
                else
                    {
				supportLibrary.setActiveTrainingByCode("rmcategory_45", "Store Overview");
                    }
				supportLibrary._bindings();

				supportLibrary.pager.init();

				supportLibrary._events.dispatchEvent("controllerInitialized");

			});

		};

		return supportLibrary;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});